import _ from 'lodash/fp'

export const getScreenLoadingEventName = (screenName, params) =>
  `${screenName}${_.flow(
    _.map(param => (_.isArray(param) ? _.sortBy(_.identity, param) : param)),
    _.join('-')
  )(params)}`
